import React, { useState } from "react";
import styled from "styled-components";
import SimpleModal from "../SimpleModal";
import Button from "../SimpleForm/UI/Button";

const StyledSubmitConfirmModal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 200px;
  h3 {
    font-size: 20px;
    /* margin-bottom: 0px; */
  }
  p {
    font-size: 17px;
  }
`;
const ModalContent = styled.div`
  padding: 0px 20px;
`;

const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const SubmitConfirmationModal = ({ onClick, disabled }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const formName = window.location.pathname.split("/")?.[3];

  return (
    <>
      <Button
        type="button"
        coloring="green"
        disabled={disabled}
        onClick={(e) => {
          e.preventDefault();
          setIsModalOpen(true);
        }}
      >
        Submit
      </Button>
      {isModalOpen && (
        <SimpleModal
          renderButton={() => null}
          toggleModal={handleToggle}
          modalStatus={isModalOpen}
        >
          <StyledSubmitConfirmModal>
            <ModalContent>
              <h3>Submit Application</h3>
              <p>
                Are you sure you want to submit this <strong>{formName}</strong>{" "}
                Application?
              </p>
            </ModalContent>
            <ModalFooter>
              <Button coloring="cancel" onClick={() => setIsModalOpen(false)}>
                Cancel
              </Button>
              <Button
                type="button"
                coloring="primary"
                disabled={disabled}
                onClick={(e) => onClick(e)}
              >
                Confirm
              </Button>
            </ModalFooter>
          </StyledSubmitConfirmModal>
        </SimpleModal>
      )}
    </>
  );
};

export default SubmitConfirmationModal;
